module.exports = __webpack_public_path__ + "img/1.b03a749e.png";